/** True when a CSS padding shorthand sets all sides to zero (treat as unset). */
export function isEffectivelyZeroPadding(value?: string): boolean {
  if (!value || typeof value !== 'string') return false;
  const parts = value.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return false;
  return parts.every((part) => {
    const n = parseFloat(part);
    return part === '0' || part === '0px' || (Number.isFinite(n) && n === 0);
  });
}

/** Parse unitless hero overlay line-height (e.g. 0.85). Percent values are normalized. */
export function parseHeroOverlayLineHeight(value?: string | number): number {
  const raw = value?.toString().trim() || '';
  if (!raw) return 0.85;
  const n = parseFloat(raw.replace(/%$/, ''));
  if (!Number.isFinite(n)) return 0.85;
  if (raw.includes('%') || n > 3) return Math.max(0.65, Math.min(1.2, n / 100));
  return Math.max(0.65, Math.min(1.2, n));
}

export function formatHeroOverlayLineHeight(value: number): string {
  const clamped = Math.max(0.65, Math.min(1.2, Math.round(value * 100) / 100));
  return String(clamped);
}

/** Parse line-height for typography panel (100–300% or unitless 1.0–3.0). */
export function parseLineHeightPercent(value?: string | number): number {
  const raw = value?.toString().replace(/%$/, '').trim() || '';
  if (!raw) return 150;
  const n = parseFloat(raw);
  if (!Number.isFinite(n)) return 150;
  return n <= 3 ? Math.round(n * 100) : Math.round(n);
}

export function formatLineHeightPercent(percent: number): string {
  const clamped = Math.max(100, Math.min(300, Math.round(percent)));
  return `${clamped}%`;
}

/** Parse letter-spacing in px (supports "0.5px" or legacy integer strings). */
export function parseLetterSpacingPx(value?: string | number): number {
  const raw = value?.toString().replace(/px$/i, '').trim() || '0';
  const n = parseFloat(raw);
  return Number.isFinite(n) ? Math.max(0, Math.min(10, n)) : 0;
}

export function formatLetterSpacingPx(px: number): string {
  const clamped = Math.max(0, Math.min(10, px));
  const rounded = Math.round(clamped * 10) / 10;
  return `${rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1)}px`;
}
